<!--
 * @Author: your name
 * @Date: 2021-11-09 14:33:17
 * @LastEditTime: 2021-11-09 18:21:54
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /ark-student-wap/src/pages/personalCenter/myHandsel/components/handselCard.vue
-->
<!--  -->
<template>
  <div class="handsel-card" @click="openHandselDetail">
    <h1 class="type-name">{{ showTitle(handselInfo.status, 1) }}</h1>
    <slot></slot>
    <ul class="course-list" v-if="handselInfo.orderPackageProductRespList">
      <li v-for="(item, index) in handselInfo.orderPackageProductRespList" :key="index">
        <h2><i v-if="item.packageName.substr(0, 1) == '【'" class="title-special-processing"></i>{{ item.packageName }}</h2>
        <p>¥{{ item.price }}</p>
      </li>
    </ul>
     <ul class="course-list" v-else>
      <li v-for="(item, index) in handselInfo.orderProductList" :key="index">
        <h2><i v-if="item.productName.substr(0, 1) == '【'" class="title-special-processing"></i>{{ item.productName }}</h2>
        <p>¥{{ item.productPrice }}</p>
      </li>
    </ul>
    <div class="order-time">
      <span>下单时间 {{ handselInfo.createTime.slice(0, 16) }}</span>
      <div>
        <div class="depositAmount">
          <span>{{handselInfo.status === 4?'定金已支付':'定金待支付'}}</span><b>￥{{ handselInfo.depositAmount }}</b>
        </div>
        <div class="balanceAmount" v-if="handselInfo.status === 4">
          <span>尾款待支付</span><b>￥{{ handselInfo.balanceAmount }}</b>
        </div>
      </div>
    </div>
    <div class="btns">
      <!-- <button class="address" @click.stop="updateInfo(1)">修改地址</button> -->
      <div>
        <button class="cancel" v-if="handselInfo.status === 1" @click.stop="updateInfo(2)">
          取消订单
        </button>
        <button class="pay" @click.stop="updateInfo(3)">立即支付</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
    };
  },
  props: {
    handselInfo: {
      type: Object,
      default: () => {},
    },
  },
  computed: {},
  watch: {},
  methods: {
    updateInfo(status) {
      this.$emit('updateInfo', { status, handselInfo: this.handselInfo });
    },
    openHandselDetail() {
      this.$router.push({
        path: '/personalCenter/handselDetail',
        query: {
          handselOrder: this.handselInfo?.depositOrderNo,
        },
      });
    },
    showTitle(status, type) {
      let statusText = '';
      let name = '';
      switch (status) {
        case 1:
          statusText = '待支付定金';
          name = '定金';
          break;
        case 4:
          statusText = '待支付尾款';
          name = '尾款';
        // eslint-disable-next-line no-fallthrough
        default:
      }
      return type === 1 ? statusText : name;
    },
  },
  created() {},
  mounted() {
  },
};
</script>
<style lang="scss" scoped>
.handsel-card {
  width: 678px;
  margin: 22px auto;
  padding: 22px 29px;
  background: #fff;
  border-radius: 14px;
  .type-name {
    padding-bottom: 11px;
    color: #ff6c02;
    font-weight: 500;
    font-size: 29px;
  }
  .time-down {
    color: #787878;
    font-weight: 400;
    font-size: 22px;
    line-height: 28px;
    span {
      color: #ff6c02;
      font-weight: normal;
      font-size: 22px;
      letter-spacing: 2px;
    }
  }
  .course-list {
    margin: 22px 0;
    padding: 22px 0;
    border-top: 1px solid #f5f5f5;
    border-bottom: 1px solid #f5f5f5;
    li {
      display: flex;
      align-items: center;
      justify-content: space-between;
        padding-bottom: 20px;
      h2 {
        width: 500px;
        overflow: hidden;
        color: #333;
        font-weight: 400;
        font-size: 33px;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      p {
        padding-top: 5px;
        color: #333;
        font-size: 25px;
      }
    }
    li:last-child{
      padding-bottom: 0;
    }
  }
  .order-time {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    span {
      color: #787878;
      font-weight: 400;
      font-size: 22px;
    }
    > div {
      .depositAmount {
        padding-bottom: 13px;
      }
      > div {
        display: flex;
        justify-content: flex-end;
        > b {
          padding-left: 14px;
          color: #ff6c02;
          font-weight: normal;
          font-size: 29px;
        }
      }
    }
  }
  .btns {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 25px;
    button {
      display: inline-block;
      min-width: 132px;
      height: 43px;
      color: #a5a5a5;
      font-weight: 500;
      font-size: 22px;
      line-height: 36px;
      background: #fff;
      border: 2px solid #a5a5a5;
      border-radius: 34px;
    }
    button.pay {
      margin-left: 16px;
      color: #fff;
      background: #ff6c02;
      border: 2px solid #ff6c02;
    }
  }
}
</style>
